/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * API request serializer for password reset request.
 * Used for OpenAPI schema generation.
 * @export
 * @interface APIAPIPasswordResetRequestRequest
 */
export interface APIAPIPasswordResetRequestRequest {
    /**
     * The user's email address
     * @type {string}
     * @memberof APIAPIPasswordResetRequestRequest
     */
    email: string;
}

/**
 * Check if a given object implements the APIAPIPasswordResetRequestRequest interface.
 */
export function instanceOfAPIAPIPasswordResetRequestRequest(value: object): value is APIAPIPasswordResetRequestRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function APIAPIPasswordResetRequestRequestFromJSON(json: any): APIAPIPasswordResetRequestRequest {
    return APIAPIPasswordResetRequestRequestFromJSONTyped(json, false);
}

export function APIAPIPasswordResetRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIAPIPasswordResetRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function APIAPIPasswordResetRequestRequestToJSON(value?: APIAPIPasswordResetRequestRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
    };
}

